import { render, staticRenderFns } from "./EventMemberships.vue?vue&type=template&id=5b0fe0a8&scoped=true&"
import script from "./EventMemberships.vue?vue&type=script&lang=js&"
export * from "./EventMemberships.vue?vue&type=script&lang=js&"
import style0 from "./EventMemberships.vue?vue&type=style&index=0&id=5b0fe0a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0fe0a8",
  null
  
)

export default component.exports